import { render, staticRenderFns } from "./groupReservation.vue?vue&type=template&id=7bff302d&scoped=true"
import script from "./groupReservation.vue?vue&type=script&lang=js"
export * from "./groupReservation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bff302d",
  null
  
)

export default component.exports